import {
  DocumentReference,
  isDocRef,
  ISODateType,
  TypeGuard,
} from '@principle-theorem/shared';
import { Gender } from '../patient/patient';
import { IPractice } from '../practice/practice';
import { isString } from 'lodash';

export interface IHeidiPatientInfo {
  id: string;
  name: string;
  gender?: HeidiGender;
  dob?: ISODateType;
}

export enum HeidiGender {
  Male = 'male',
  Female = 'female',
  Other = 'other',
  Unknown = 'unknown',
}

export const HEIDI_GENDER_MAP: Record<Gender, HeidiGender> = {
  [Gender.Male]: HeidiGender.Male,
  [Gender.Female]: HeidiGender.Female,
  [Gender.Other]: HeidiGender.Other,
  [Gender.NotSpecified]: HeidiGender.Unknown,
};

export interface IHeidiAuthenticateRequest {
  practiceRef: DocumentReference<IPractice>;
  heidiUserReference: string;
  email: string;
}

export const isHeidiAuthenticateRequest =
  TypeGuard.interface<IHeidiAuthenticateRequest>({
    practiceRef: isDocRef,
    heidiUserReference: isString,
    email: isString,
  });

export interface IHeidiAuthenticateResponse {
  token: string;
  expiration_time: string;
}
